import { withIcon } from './withIcon';

export const MarkerSvg = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.1679 3.85188L15.4712 0.155143C15.2642 -0.0517144 14.9287 -0.0517144 14.7218 0.155143L5.52993 9.34696C5.45582 9.42114 5.4053 9.51567 5.38489 9.61846L4.469 14.2311C4.4346 14.4046 4.48893 14.5839 4.61404 14.709C4.71443 14.8093 4.84958 14.8642 4.98876 14.8642C5.02303 14.8642 5.05764 14.8608 5.09198 14.854L9.7046 13.9381C9.80746 13.9177 9.90192 13.8672 9.9761 13.7931L19.1679 4.60124C19.3748 4.39432 19.3748 4.05888 19.1679 3.85188ZM5.87667 12.5834L6.35538 10.1724L9.15064 12.9677L6.73963 13.4464L5.87667 12.5834Z"
      fill="currentColor"
    />
    <path
      d="M14.5473 16.0418C9.47979 13.9203 6.18081 17.4288 5.19555 17.9617C3.9361 18.6428 2.16184 19.4432 1.7494 18.0576C1.50058 17.2217 2.84593 16.3282 3.7368 16.0498C4.38677 15.8466 4.10919 14.8235 3.45506 15.0279C2.07163 15.4603 0.420861 16.6256 0.710306 18.2663C0.925359 19.4854 2.4532 20.5973 5.39908 19.0515C7.54029 17.928 8.99486 15.601 13.5048 16.8061C14.9862 17.2018 16.1837 18.1675 16.6965 19.636C16.9203 20.2768 17.9443 20.0012 17.7184 19.3543C17.1719 17.7891 16.0662 16.6777 14.5473 16.0418Z"
      fill="currentColor"
    />
  </svg>
);

export const Marker = withIcon(MarkerSvg);
